import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import '@/style/nprogress.css';

NProgress.configure({
    showSpinner: false,
    minimum: 0.08,
    speed: 300,
});

// Delay before the bar appears so instant navigations don't flash it.
const PROGRESS_DELAY_MS = 200;
let startTimer = null;

export function startPageProgress(to, from) {
    if (to.path === from.path) return;
    clearTimeout(startTimer);
    startTimer = setTimeout(() => {
        startTimer = null;
        NProgress.start();
    }, PROGRESS_DELAY_MS);
}

export function finishPageProgress() {
    if (startTimer !== null) {
        clearTimeout(startTimer);
        startTimer = null;
        return;
    }
    NProgress.done();
}
